import Overview from './overview.vue';
import MobFull from './mob-full.vue';
import MobDetail from '@rebuild/materials/shared/question/mobile/MobDetailWithoutHHMM.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull,
	'mob-detail': MobDetail
};
